// extracted by mini-css-extract-plugin
export default {"reports":"reports_reports__om9Lz"};